import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  ASIENTOSCONTABLES_DETALLES,
  ASIENTOSCONTABLES_LISTA,
  ASIENTOSCONTABLES_NUEVO,
  ASIENTOSCONTABLES_NUEVODIARIO_APLIACIONNOTA,
  ASIENTOSCONTABLES_UTILES,
  ASIENTOSCONTABLESORIGENDIARIO_NUEVO,
  ASIENTOSCONTABLES_NUEVOOGCANJE,
  ASIENTOSCONTABLES_NUEVOOGCOBR,
  ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS,
  ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS,
  ASIENTOSCONTABLES_REPORTES_LIBRODIARIO,
  ASIENTOSCONTABLES_REPORTES_LIBROMAYOR,
  ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION,
  ASIENTOSCONTABLES_REPORTES_BALANCEGENERAL,
  ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE,
  ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS,
  ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS,
  ASIENTOSCONTABLES_IMPORTAR,
  ASIENTOSCONTABLES_REPORTES_LIBROANEXOS,
  ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS,
  ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR,
  ASIENTOSCONTABLES_REPORTES_DETRACCIONES,
  ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES,
  ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS,
  ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO,
  ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR,
  ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS,
  ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE,
  ASIENTOSCONTABLES_NODOMICILIADOS,
  ASIENTOSCONTABLES_SIRE_REPORTES,
  ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE
} from 'constants/codigosTransacciones'

import ListaPage from './lista'
import SIREReportesPage from './sireReportes'
import DetallesPage from './detalles'

import UtilesPage from './utiles'
import NuevoOgCompVentPage from './nuevoOgCompVent'
import NuevoOgDiarioPage from './nuevoOgDiario'
import NuevoOgDiarioAplicacionNotaPage from './nuevoOgDiarioAplicacionNota'
import NuevoOgCanjePage from './nuevoOgCanje'
import NuevoOgCobrPagoPage from './nuevoOgCobrPago'
import NoDomiciliadosPage from './noDomiciliados'

import * as ConsultasPage from './consultas'
import * as ReportesPages from './reportes'
import * as ImportarPages from './importar'
import * as LibrosElectronicoPages from './librosElectronicos'

export default function AsientosContablesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ASIENTOSCONTABLES_NUEVO}/:idAsientoContable`} component={NuevoOgCompVentPage} />
        <Route path={`/${ASIENTOSCONTABLESORIGENDIARIO_NUEVO}/:id`} component={NuevoOgDiarioPage} />
        <Route path={`/${ASIENTOSCONTABLES_DETALLES}/:idAsientoContable`} component={DetallesPage} />
        <Route path={`/${ASIENTOSCONTABLES_UTILES}`} component={UtilesPage} />
        <Route path={`/${ASIENTOSCONTABLES_CONSULTA_DOCUMENTOS}`} component={ConsultasPage.ConsultasDocumentosPage} />
        <Route
          path={`/${ASIENTOSCONTABLES_CONSULTA_CUENTACORRIENTE}`}
          component={ConsultasPage.ConsultasCuentasCorrientesPage}
        />
        <Route path={`/${ASIENTOSCONTABLES_NUEVO}`} component={NuevoOgCompVentPage} />
        <Route path={`/${ASIENTOSCONTABLES_NUEVODIARIO_APLIACIONNOTA}`} component={NuevoOgDiarioAplicacionNotaPage} />
        <Route path={`/${ASIENTOSCONTABLESORIGENDIARIO_NUEVO}`} component={NuevoOgDiarioPage} />
        <Route path={`/${ASIENTOSCONTABLES_NUEVOOGCANJE}`} component={NuevoOgCanjePage} />
        <Route path={`/${ASIENTOSCONTABLES_NUEVOOGCOBR}`} component={NuevoOgCobrPagoPage} />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_REGISTROVENTAS}`}
          component={ReportesPages.ReporteRegistroVentasPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_REGISTROCOMPRAS}`}
          component={ReportesPages.ReporteRegistroComprasPage}
        />
        <Route path={`/${ASIENTOSCONTABLES_REPORTES_LIBRODIARIO}`} component={ReportesPages.ReporteLibroDiarioPage} />
        <Route path={`/${ASIENTOSCONTABLES_REPORTES_LIBROMAYOR}`} component={ReportesPages.ReporteLibroMayorPage} />
        <Route path={`/${ASIENTOSCONTABLES_REPORTES_LIBROANEXOS}`} component={ReportesPages.ReporteLibroAnexosPage} />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_LIBROAUXILIAR}`}
          component={ReportesPages.ReporteLibroAuxiliarPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_LIBROCAJABANCOS}`}
          component={ReportesPages.ReporteLibroCajaBancosPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_BALANCECOMPROBACION}`}
          component={ReportesPages.ReporteBalanceComprobacionPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_BALANCEGENERAL}`}
          component={ReportesPages.ReporteBalanceGeneralPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_ANALISISBALANCE}`}
          component={ReportesPages.ReporteAnalisisBalancePage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_REGISTROPROVEEDORES}`}
          component={ReportesPages.ReporteRegistroProveedoresPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_DETRACCIONES}`}
          component={ReportesPages.ReporteDeDetraccionesPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_REPORTES_CONSISTENCIAS}`}
          component={ReportesPages.ReporteConsistenciasPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROCOMPRAS}`}
          component={LibrosElectronicoPages.LibroElectronicoRegistroComprasPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_LIBROELECTRONICO_REGISTROVENTAS}`}
          component={LibrosElectronicoPages.LibroElectronicoRegistroVentasPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_LIBROELECTRONICO_LIBRODIARIO}`}
          component={LibrosElectronicoPages.LibroElectronicoLibroDiarioPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_LIBROELECTRONICO_LIBROMAYOR}`}
          component={LibrosElectronicoPages.LibroElectronicoLibroMayorPage}
        />
        <Route
          path={`/${ASIENTOSCONTABLES_LIBROELECTRONICO_RVIE}`}
          component={LibrosElectronicoPages.LibroElectronicoLibroRVIEPage}
        />
        <Route path={`/${ASIENTOSCONTABLES_IMPORTAR}`} component={ImportarPages.MainPage} />
        <Route path={`/${ASIENTOSCONTABLES_LISTA}`} component={ListaPage} />
        <Route path={`/${ASIENTOSCONTABLES_SIRE_REPORTES}`} component={SIREReportesPage} />
        <Route path={`/${ASIENTOSCONTABLES_NODOMICILIADOS}`} component={NoDomiciliadosPage} />
      </Switch>
    </Suspense>
  )
}
